module.exports = __webpack_public_path__ + "img/ife-aa_header_laptop.22635185.png";